<template>
  <div class="app-container">
    <div class="catch-box">
      <h2 class="catch-title">
        <span class="stroke">給湯器を安く早く交換するなら</span><br>
        <span class="highlight">専門業者がおすすめ！</span>
      </h2>
    </div>
    <ComparisonTable />
    <RecommendationReasons />
  </div>
</template>

<script setup>
import ComparisonTable from './ComparisonTable.vue'
import RecommendationReasons from './RecommendationReasons.vue'
</script>

<style scoped>
.app-container {
  background: #f0f0fb;
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;
}

.catch-box {
  text-align: center;
  margin-bottom: 20px;
  width: 100%;
  max-width: 900px;
  position: relative;
}

.catch-title {
  font-size: 30px;
  font-weight: bold;
  color: #333;
  display: inline-block;
  position: relative;
  margin-bottom: 0;
  margin-top: 10px;
}

.catch-title .highlight {
  background: linear-gradient(transparent 60%, #ffeb3b 60%);
  color: #d32f2f;
  font-weight: bold;
  line-height: 0.7;
}

.arrow-down {
  width: 0;
  height: 0;
  margin: 15px auto 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-top: 15px solid #3f51b5; 
}

.stroke {
  color: black;
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 600px) {
  .catch-box span{
    font-size: 1.4rem;
  }

  .catch-title {
    line-height: 1;
  }
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 480px) {
  .catch-box span {
    font-size: 1.3rem;
  }

  .app-container {
    padding: 0;
  }
}
</style>
